import { render, staticRenderFns } from "./OfferSlotGroupListOption.vue?vue&type=template&id=50782328"
import script from "./OfferSlotGroupListOption.vue?vue&type=script&lang=js"
export * from "./OfferSlotGroupListOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports